import cookie from 'vue-cookie'
import store from '../vuex/store'
import { Message } from 'gsum-uikit-vue'
import { globalService } from '@/service/globalService'
var interceptors = {
  config: config => {
    config.headers['Content-Type'] = 'application/json; charset=utf-8'
    if (process.env.NODE_ENV === 'development') {
      let ticket = ''
      if (!store.state.comeFromOldSystem) {
        ticket = cookie.get('cird-ticket')
        if (ticket) {
          ticket = ticket.replace(/"/g, '')
        }
        if (config.url.indexOf('?') !== -1) {
          config.url = config.url + '&ticket=' + encodeURIComponent(ticket)
        } else {
          config.url = config.url + '?ticket=' + encodeURIComponent(ticket)
        }
      } else {
        ticket = cookie.get('ticket')
        if (ticket) {
          ticket = ticket.replace(/"/g, '')
        }
        if (config.url.indexOf('?') !== -1) {
          config.url = config.url + '&ticket=' + encodeURIComponent(ticket)
        } else {
          config.url = config.url + '?ticket=' + encodeURIComponent(ticket)
        }
      }
    }
    return config
  },
  err: err => {
    return Promise.reject(err)
  },
  response: response => {
    if (
      response.data.statusCode === '4001' ||
      response.data.statusCode === '4002'
    ) {
      Message({
        type: 'error',
        message: response.data.message
      })
    } else {
      return response
    }
  },
  error: error => {
    console.log('error.response', error)

    if (error.response) {
      if (error.response.status === 404) {
      } else if (error.response.status === 400) {
        globalService.showErrNofify(error.response.data.Message)
        return Promise.reject(error)
      } else if (error.response.status === 401) {
         // 去登录
        cookie.delete('userInfo')
        cookie.delete('ticket')
        cookie.delete('cird-ticket')
        if (store.state.comeFromOldSystem) {
          window.location.href = 'index.html'
        } else {
          window.location.href = ''
        }
         // 没权限，刷新页面会跳转登录页
      } else if (error.response.status === 500) {
        error.response.data.Message = '服务器错误，请联系管理员！'
      } else if (error.response.status === -1) {
      } else {
      }
    }
    return Promise.reject(error.response) // 返回处理后的错误信息
  }
}

export default interceptors



// WEBPACK FOOTER //
// ./src/service/httpInterceptors.js